// 재직 상태 매핑
export const employmentStatusMap = {
  ACTIVE: '재직',
  ON_LEAVE: '휴직',
  RESIGNED: '퇴사',
}

// 근무 형태 매핑
export const workTypeMap = {
  FULL_TIME: '정규직',
  CONTRACT: '계약직',
  CONVERSION: '정규직 전환용',
}

// 재직 상태를 한글로 변환하는 헬퍼 함수
export const getEmploymentStatusDisplay = (status) => {
  return employmentStatusMap[status] || status || '재직'
}

// 근무 형태를 한글로 변환하는 헬퍼 함수
export const getWorkTypeDisplay = (workType) => {
  return workTypeMap[workType] || workType || '정규직'
}
